module.exports = __webpack_public_path__ + "assets/img/20_161_big.1ead7e84.jpg";